<mc-status-incident-bar class="mc-flex-grow-0 mc-flex-shrink-0"></mc-status-incident-bar>
<router-outlet></router-outlet>